import * as React from 'react';
import { SVGProps } from 'react';

const IconConnectionSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m13.03 6.728 1.798-1.8a3 3 0 0 1 4.243 4.244l-3.536 3.535a3 3 0 0 1-4.726-.633 2.993 2.993 0 0 0-.93.633l-.637.636a5 5 0 0 0 7.707.778l3.536-3.535a5 5 0 0 0-7.07-7.071l-2.703 2.702c.79.037 1.574.207 2.318.51z" />
    <path d="M3.515 13.414a5 5 0 0 0 7.07 7.071l2.9-2.9a7.018 7.018 0 0 1-2.423-.405l-1.89 1.891a3 3 0 1 1-4.243-4.243l3.535-3.535a3 3 0 0 1 4.727.633 2.99 2.99 0 0 0 .93-.633l.637-.636a5 5 0 0 0-7.707-.778l-3.536 3.535z" />
  </svg>
);
export default IconConnectionSizeM;
